// extracted by mini-css-extract-plugin
export default {"loginWrapper":"Login_loginWrapper__Lpnpx"};